import type { FC } from 'react'
import type { FooterColumnType } from '../../../types'
import { FooterLink } from '../footer-link/FooterLink'
import { FooterStoreLink } from '../footer-store-link/FooterStoreLink'
import styles from './FooterColumn.module.scss'

interface FooterColumnProps {
  column: FooterColumnType
}

export const FooterColumn: FC<FooterColumnProps> = ({ column }) => (
  <div className={styles.column}>
    {column.title && <h3 className={styles.title}>{column.title}</h3>}
    {column.items.map((item, i) => (
      <div key={i} className={styles.item}>
        {item.type === 'link' && <FooterLink item={item} />}
        {item.type === 'customComponent' && <item.component />}
        {item.type === 'storeLinkGroup' && (
          <div className={styles.storeLinkGroup}>
            <FooterStoreLink item={item} />
          </div>
        )}
      </div>
    ))}
  </div>
)
